export default __webpack_public_path__ + "30e99b54584f9fc77d2f04b6701a084a.svg";